import React from "react";
import { FeedHeader } from "web/react/components/feed-header/feed-header";
import { SaveSearchButton } from "web/react/components/save-search-button/save-search-button";
import { SearchNoResults } from "web/react/components/search-no-results/search-no-results";
import { gettext } from "web/script/modules/django-i18n";
import { SearchLayoutSerializer } from "web/types/serializers";

interface SearchPageProps {
    data: SearchLayoutSerializer;
}

export function SearchPage({ data }: SearchPageProps): JSX.Element {
    if (!data.has_results) {
        return <SearchNoResults htmlText={data.no_results_cannot_filter_body_html as string} />;
    }

    return (
        <>
            <FeedHeader
                // # "Results for "{search_term}""
                title={gettext("search_summary_bar.results_for_term", {
                    search_term: data.summary_bar.search_term,
                })}
                actions={
                    <SaveSearchButton
                        term={data.summary_bar.search_term}
                        gender={data.summary_bar.search_gender}
                        next={data.summary_bar.search_next}
                    />
                }
            />
        </>
    );
}
